import { render } from "./communityQuiz.vue?vue&type=template&id=21870219&scoped=true"
import script from "./communityQuiz.vue?vue&type=script&lang=js"
export * from "./communityQuiz.vue?vue&type=script&lang=js"

import "./communityQuiz.vue?vue&type=style&index=0&id=21870219&lang=css"
import "./communityQuiz.vue?vue&type=style&index=1&id=21870219&scoped=true&lang=css"

import exportComponent from "D:\\work\\sckj\\wwei\\ww-vue\\wwei_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21870219"]])

export default __exports__